import { AsyncThunk, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { filterUrls } from "../../services/api.enums";
import { filterTableDataAPI } from "../../services/CRUDServices";

export const filterGroupPayment: AsyncThunk<{}, {}, {}> = createAsyncThunk(
  "groupPayment",
  async (body: any) => {
    let { data } = await filterTableDataAPI(
      filterUrls.groupPayment,
      body.pageNumber,
      {
        ...body,
        pageNumber: body.pageNumber,
        pageSize: 10,
      },
      true,
      10,
      false
    );
    return { data:data.payload };
  }
);

const initialState: any = {
  groupPaymentLists: [],
  fetchpost: false,
  errorMessage: null,
  filter: {},
};

const PaymentGroupSlice = createSlice({
  initialState: initialState,
  name: "groupPaymentLists",
  reducers: {

    clearGroupPayment: (state) => {
      state.deliveryList = [];
    },
    setFilter: (state, action) => {
      state.filter = action.payload;
    },
  },
  extraReducers: {
    [filterGroupPayment.fulfilled as any]: (state, action) => {
      state.groupPaymentLists = action.payload.data;
      state.fetchPost = false;
    },
    [filterGroupPayment.pending as any]: (state) => {
      state.fetchPost = true;
    },
    [filterGroupPayment.rejected as any]: (state) => {
      state.fetchPost = false;
      state.errorMessage = "wrong";
    },
  },
});

export const { clearGroupPayment, setFilter } = PaymentGroupSlice.actions;
export default PaymentGroupSlice.reducer;
